import React from "react";
import PdfBase from "./PdfBase";
import { generateRenovationPdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  rennovationRows,
  mode,
  isSdg,
  tableRows,
  secondTableRows,
  totalRennovations,
  totalQualifyingCost,
  totalQualifyingCostBF,
  totalCostIncurred,
  totalDeduction,
  totalCostCF,
  totalSecondCostIncurred,
  totalSecondQualifyingCost,
  totalSecondQualifyingCostBF,
  totalSecondDeduction,
  totalSecondCostCF,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    rennovationRows,
    mode,
    isSdg,
    tableRows,
    secondTableRows,
    totalRennovations,
    totalQualifyingCost,
    totalQualifyingCostBF,
    totalCostIncurred,
    totalDeduction,
    totalCostCF,
    totalSecondCostIncurred,
    totalSecondQualifyingCost,
    totalSecondQualifyingCostBF,
    totalSecondDeduction,
    totalSecondCostCF,
    notes,
    reviewNotes,
  ];
  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) => generateRenovationPdf(forView, ...sharedArgs)}
        downloadName='Renovation and Refurbishment Deductions Under S14N'
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateRenovationPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
